import React from "react";
import { BlockProps } from "./blocks/registry";
import { Heading } from "../design-system/atoms/Heading";
import Icon from "../design-system/atoms/Icon";

export default function PourquoiLMS({ data }: BlockProps) {
  if (!data) return null;

  if (data.variant === "prescripteur") {
    return (
      <section className="py-24 bg-white">
        <div className="lms-container text-center">
          {/* ✅ Titre */}
          <Heading
            as="h2"
            className="text-3xl lg:text-5xl font-bold mb-16 text-center text-text"
          >
            {(() => {
              const words = data.title.split(" ");
              const lastThree = words.slice(-4).join(" ");
              const firstPart = words.slice(0, -4).join(" ");
              return (
                <>
                  {firstPart}{" "}
                  <span className="text-secondary font-semibold">
                    {lastThree}
                  </span>
                </>
              );
            })()}
          </Heading>



          {/* ✅ Grille d’icônes */}
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 pt-14 gap-10 lg:gap-12">
            {data.choixMenus.map((item) => (
              <div
                key={item.id}
                className="flex flex-col items-center text-center space-y-4 p-5 hover:rounded-2xl hover:border-gray-200 hover:shadow-[0px_8px_30px_rgba(0,0,0,0.1)]"
              >
                {/* Icône cercle */}
                <div className="relative flex items-center justify-center w-20 h-20 transition-transform duration-300
              hover:scale-110  ">
                  <Icon
                    src={item.icon.url}
                    size={30}
                    alt={item.iconAlt || "Icon"}
                    className="w-full h-full object-contain"
                  />
                </div>

                {/* Barre verte */}
                <div className="w-20 h-[4px] bg-primaryforeground rounded-full"></div>

                {/* Texte */}
                <p className="text-gray-700 text-base lg:text-lg leading-snug max-w-[250px]">
                  {item.descr}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  } else {
    return (
      <section
        key={data.id}
        className="bg-accent lg:min-h-[65vh] lg:mt-[-200px] flex justify-center items-center">
        <div className="lms-container pt-5 pb-8 lg:pt-24  flex flex-col items-center ">
          <Heading
            as="h2"
            className="text-4xl lg:text-5xl text-center font-bold text-text pt-6 2xl:pt-20 3xl:pt-10"
          >
            {data.title ? (
              <>
                {data.title.split(" ").slice(0, -3).join(" ")}{" "}
                <span className="text-white">
                  {data.title.split(" ").slice(-3).join(" ")}
                </span>
              </>
            ) : (
              "Pourquoi choisir Les Menus Services ?"
            )}
          </Heading>

          <div className="flex flex-col gap-6 lg:flex-row max-w-7xl">
            {data.choixMenus.map((card: any) => (
              <article
                key={card.id}
                className="flex-1 bg-white rounded-2xl px-4 py-6 text-center transition shadow-lg"
                style={{ boxShadow: "0px 0px 29.8px rgba(0,0,0,0.15)" }}
              >
                <Icon
                  src={card.icon.url}
                  alt={card.iconAlt ?? card.descr}
                  className="mx-auto h-20 w-20 object-contain"
                />

                {card.titre && (
                  <h3 className="mt-6 text-2xl font-semibold text-primaryGreen">
                    {card.titre}
                  </h3>
                )}

                <p className="mt-4 text-base leading-relaxed text-text">
                  {card.descr}
                </p>
              </article>
            ))}
          </div>
        </div>

      </section>

    );

  }

}

